import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  topLink: {
    color: 'white',
    textDecoration: 'none',
  },
});